document.addEventListener('DOMContentLoaded', function() {
    // Target the exact elements based on the HTML structure
    const mediaGallery = document.querySelector('.media-gallery');
    const titleRow = document.querySelector('.title-row');
    const productInfoBlock = document.querySelector('.lightly-spaced-row.not-in-quickbuy');
    const productForm = document.querySelector('.product-form');

    if (!mediaGallery || !titleRow || !productInfoBlock) {
        console.log('Some elements not found:', {
            mediaGallery: !!mediaGallery,
            titleRow: !!titleRow,
            productInfoBlock: !!productInfoBlock
        });
        return;
    }

    function handleMobileLayout() {
        const isMobile = window.innerWidth <= 767.98;

        if (isMobile) {
            // Move title-row and product-info-block above media-gallery
            if (mediaGallery.parentNode) {
                mediaGallery.parentNode.insertBefore(titleRow, mediaGallery);
                mediaGallery.parentNode.insertBefore(productInfoBlock, mediaGallery);
            }
        } else {
            // Restore desktop layout - move elements back to their original position
            if (productForm) {
                productForm.insertBefore(titleRow, productForm.firstChild);
                productForm.insertBefore(productInfoBlock, productForm.children[1]);
            }
        }
    }

    // Initial layout handling
    handleMobileLayout();

    // Handle layout on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleMobileLayout, 100);
    });
}); 